<div id="container" class="main-dynamic-container">
  <div class="question-container">{{ "report.item.basicInformation" | translate }}</div>
  <div class="flex-row row-container">
    <div id="pie-chart" #leftContainer class="content-dynamic-container content-circle-progress flex-1">
      @if (radius) {
        <circle-progress
          [percent]="report.doc * 100"
          [radius]="radius"
          [outerStrokeWidth]="radius / 10"
          [innerStrokeWidth]="radius / 12"
          [outerStrokeColor]="outerStrokeColor"
          [innerStrokeColor]="innerStrokeColor"
          [titleFontSize]="radius / 2 + ''"
          [unitsFontSize]="radius / 2 + ''"
          [subtitleFontSize]="radius / 6 + ''"
          [responsive]="false"
          [space]="radius / 20" />
      }
    </div>
    <div #rightContainer class="content-dynamic-container content-info-container flex-1">
      <div class="content-dynamic-container">
        <div class="label-span">
          <label>{{ "report.item.operatingCompany" | translate }}</label>
          <span>{{ report.responsible?.orgDescription }} - {{ report.responsible?.orgCode }}</span>
        </div>
      </div>
      <div class="content-dynamic-container flex-1" id="report-end-date">
        <sag-ui-date-range-picker
          [formGroup]="dateRangePickerFormGroup"
          formControlNameStart="reportStartDate"
          formControlNameEnd="reportEndDate"
          [label]="'Reporting period'"
          [placeholder]="'MM/DD/YYYY - MM/DD/YYYY'"
          [disabled]="true"
          (click)="dateRangePickerChanged()" />
      </div>
      <div id="specialist-functions" class="content-dynamic-container">
        <div class="label-span">
          <label [innerHTML]="'report.item.specialistFunctionLines' | translate"></label>
          <reporting-tool-chip [value]="specialists" [readonly]="true" [showIconForValues]="{ icon: ['fas', 'signature'], values: mainSpecialists }" />
        </div>
      </div>
      <div id="executive-members" class="content-dynamic-container">
        <div class="label-span">
          <label [innerHTML]="'report.item.executiveMemberLines' | translate"></label>
          <reporting-tool-chip [value]="responsible" [showIconForValues]="{ icon: ['fas', 'signature'], values: mainResponsible }" [readonly]="true" />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="main-dynamic-container">
  <div class="question-container">{{ "report.actions.signatureInformation" | translate }}</div>
  <div class="flex-row row-container signature-container">
    <div id="specialist-signature" class="content-dynamic-container flex-1">
      <label>{{ "report.item.specialistSignature" | translate }}</label>
      <div class="signature-meta-container">
        <div class="signature-text">
          @if (IS_TRS_PROJECT) {
            @for (signer of specialistSigners; track signer) {
              @if (signatureForSigner(signer.id)) {
                <span class="signature-meta" [ngClass]="'trs'">
                  {{
                    "report.item.signedByTime"
                      | translate
                        : {
                            date: (signatureForSigner(signer.id).date | localizedDate: "standard"),
                            user: signatureForSigner(signer.id).fullName
                          }
                  }}
                </span>
              } @else {
                <span class="signature-meta" [ngClass]="'trs'"> {{ "report.item.notSignedYet" | translate }} ({{ signer.fullName }}) </span>
              }
            }
          } @else if (IS_PRODUCT_SAFETY_PROJECT) {
            @if (singleSignatureResult(specialistSignature)?.id) {
              <span class="signature-meta" [ngClass]="'product-safety'">
                {{
                  "report.item.signedByTime"
                    | translate
                      : {
                          date: (singleSignatureResult(specialistSignature).date | localizedDate: "standard"),
                          user: singleSignatureResult(specialistSignature).fullName
                        }
                }}
              </span>
            } @else {
              <span class="signature-meta" [ngClass]="'product-safety'">
                {{ "report.item.notSignedYet" | translate }}
              </span>
            }
          }
        </div>
        @if (specialistCanSign) {
          <button (click)="signAsSpecialist()" class="sign-button">
            <span class="sign-label">Sign</span>
            <fa-icon [icon]="['fas', 'signature']" size="2x"></fa-icon>
          </button>
        } @else {
          <div class="signature-icon">
            @if (IS_TRS_PROJECT) {
              <fa-icon [icon]="['fas', 'signature']" size="2x"></fa-icon>
              <fa-icon
                [icon]="['fas', reportSignedBySpecialists || signatureForSigner(guard.currentUser.id) ? 'check' : 'times']"
                [ngClass]="{ done: reportSignedBySpecialists || signatureForSigner(guard.currentUser.id) }"
                class="validator"></fa-icon>
            } @else if (IS_PRODUCT_SAFETY_PROJECT) {
              <fa-icon [icon]="['fas', 'signature']" size="2x"></fa-icon>
              <fa-icon class="validator" [ngClass]="{ done: !!specialistSignature }" [icon]="['fas', !!specialistSignature ? 'check' : 'times']"></fa-icon>
            }
          </div>
        }
      </div>
    </div>
    <div id="executive-signature" class="content-dynamic-container flex-1">
      <label>{{ "report.item.responsibleSignature" | translate }}</label>
      <div class="signature-meta-container">
        <div class="signature-text">
          @if (responsibleSignature) {
            @if (responsibleSignature.id) {
              <span class="signature-meta" [ngClass]="IS_TRS_PROJECT ? 'trs' : 'product-safety'">
                {{
                  "report.item.signedByTime"
                    | translate
                      : {
                          date: (responsibleSignature.date | localizedDate: "standard"),
                          user: responsibleSignature.fullName
                        }
                }}
              </span>
            } @else if (responsibleSignature?.date) {
              <span class="signature-meta" [ngClass]="IS_TRS_PROJECT ? 'trs' : 'product-safety'">
                {{ "report.item.signatureTime" | translate: { date: (responsibleSignature.date | localizedDate: "standard") } }}
              </span>
            }
          }
          @if (!responsibleSignature?.date) {
            <span class="signature-meta" [ngClass]="IS_TRS_PROJECT ? 'trs' : 'product-safety'">
              {{ "report.item.notSignedYet" | translate }}
            </span>
          }
        </div>
        @if (responsibleCanSign) {
          <button (click)="signForResponsible()" class="sign-button">
            <span class="sign-label">Sign</span>
            <fa-icon [icon]="['fas', 'signature']" size="2x"></fa-icon>
          </button>
        } @else {
          <div class="signature-icon">
            <fa-icon [icon]="['fas', 'signature']" size="2x"></fa-icon>
            <fa-icon class="validator" [ngClass]="{ done: !!responsibleSignature }" [icon]="['fas', !!responsibleSignature ? 'check' : 'times']"></fa-icon>
          </div>
        }
      </div>
    </div>
  </div>
</div>
